import { html, LitElement } from "lit";
import { customElement } from 'lit/decorators.js';
import { localized, msg } from "@lit/localize";
import style from './usos-copyright.scss';

/**
 * Copyright row and debug data holder.
 *
 * @slot debug - Slot for extra debug data, links, etc.
 */

@customElement('usos-copyright')
@localized()
export class UsosCopyright extends LitElement {
    static override styles = style;

    override render() {
        return html`
            <div id="layoutCopyright">
                <p>${msg('©\u00a0Międzyuniwersyteckie Centrum Informatyzacji. Wszystkie prawa zastrzeżone.')}</p>
                <slot name="debug"></slot>
            </div>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'usos-copyright': UsosCopyright
    }
}
